

export const emailTip = 'hola@bitcar.mx';
export const emailTipTo = 'mailto:hola@bitcar.mx';
export const whatsTip = 'https://wa.me/5215590204974';
